import React from "react";

import TextObj from "./text.js";
import UploadObj from "./upload.js";
import RowObj from "./row.js";
import SpacingObj from "./spacing.js";
import ButtonObj from "./button.js";
import CartObj from "./cart.js";
import SocialfollowObj from "./socialfollow.js";
import DividerObj from "./divider.js";
import HeaderObj from "./header.js";
import FooterObj from "./footer.js";
import OrderSummaryObj from "./ordersummary.js";
import RecommendationObj from "./recommendation.js";
import DiscountObj from "./discount.js";
import ListObj from "./list.js";
import ProductSelectionObj from "./productselection.js";
import CustomHtmlObj from "./customhtml.js";
import CrallRecommendationObj from "./crallrecommendation.js";
import CrallRecommendationDynamoObj from "./crallrecommendationdynamo.js";
import ShippingTrackerObj from "./shippingtracker.js";
import RecheckoutObj from "./recheckout.js";

import Button from "../components/builder/Button.js";
import Cart from "../components/builder/Cart.js";
import Spacing from "../components/builder/Spacing.js";
import FileUpload from "../components/builder/FileUpload.js";
import Text from "../components/builder/Text.js";
import Divider from "../components/builder/Divider.js";
import Socialfollow from "../components/builder/Socialfollow.js";
import Header from "../components/builder/Header.js";
import Footer from "../components/builder/Footer.js";
import OrderSummary from "../components/builder/OrderSummary.js";
import Recommendation from "../components/builder/Recommendation.js";
import Discount from "../components/builder/Discount.js";
import List from "../components/builder/List.js";
import ProductSelection from "../components/builder/ProductSelection";
import CustomHtml from "../components/builder/CustomHtml";
import ShippingTracker from "../components/builder/ShippingTracker";
import Recheckout from "../components/builder/Recheckout";
import CrallRecommendation from "../components/builder/Crallrecommendation";
import CrallRecommendationDynamo from "../components/builder/crallrecommendationdynamo";

export function getItemObject(type, data) {
    let el = false;

    switch (type) {
        case "upload":
            el = new UploadObj(data);
            break;

        case "text":
            el = new TextObj(data);
            break;

        case "button":
            el = new ButtonObj(data);
            break;

        case "cart":
            el = new CartObj(data);
            break;

        case "spacing":
            el = new SpacingObj(data);
            break;

        case "divider":
            el = new DividerObj(data);
            break;

        case "socialfollow":
            el = new SocialfollowObj(data);
            break;

        case "header":
            el = new HeaderObj(data);
            break;

        case "footer":
            el = new FooterObj(data);
            break;

        case "ordersummary":
            el = new OrderSummaryObj(data);
            break;

        case "recommendation":
            el = new RecommendationObj(data);
            break;
        case "crallrecommendation":
            el = new CrallRecommendationObj(data);
            break;
        case "crallrecommendationdynamo":
            el = new CrallRecommendationDynamoObj(data);
            break;

        case "list":
            el = new ListObj(data);
            break;

        case "productselection":
            el = new ProductSelectionObj(data);
            break;

        case "discount":
            el = new DiscountObj(data);
            break;

        case "customhtml":
            el = new CustomHtmlObj(data);
            break;

        case "shippingtracker":
            el = new ShippingTrackerObj(data);
            break;

        case "recheckout":
            el = new RecheckoutObj(data);
            break;
    }

    return el;
}

export function getItemComponent(element, row_cols, sidebar = false) {
    switch (element.type) {
        case "upload":
            return (
                <FileUpload
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "text":
            return (
                <Text row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "button":
            return (
                <Button row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "cart":
            return (
                <Cart row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "spacing":
            return (
                <Spacing
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "divider":
            return (
                <Divider
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "socialfollow":
            return (
                <Socialfollow
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "recheckout":
            return (
                <Recheckout
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "list":
            return (
                <List row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "header":
            return (
                <Header row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "footer":
            return (
                <Footer row_cols={row_cols} sidebar={sidebar} id={element.id} />
            );
            break;

        case "ordersummary":
            return (
                <OrderSummary
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "recommendation":
            return (
                <Recommendation
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;
        case "crallrecommendation":
            return (
                <CrallRecommendation
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;
        case "crallrecommendationdynamo":
            return (
                <CrallRecommendationDynamo
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "productselection":
            return (
                <ProductSelection
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "discount":
            return (
                <Discount
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "customhtml":
            return (
                <CustomHtml
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;

        case "shippingtracker":
            return (
                <ShippingTracker
                    row_cols={row_cols}
                    sidebar={sidebar}
                    id={element.id}
                />
            );
            break;
    }

    return false;
}



// WEBPACK FOOTER //
// ./helpers/functions.js